import * as React from 'react';
import * as elog from '@reverbdotcom/commons/dist/elog';
import bind from '@reverbdotcom/commons/dist/bind';
import Modal from '@reverbdotcom/commons/dist/components/modal';
import ChallengeShopper, { IExternalProps as IChallengeShopperProps } from './challenge_shopper';
import { trackView, IEventData } from '@reverbdotcom/commons/dist/tracker';

interface State {
  isOpen: boolean;
}

const TAG = 'adyen.threeds2_challenge_shopper_modal';

export default class ChallengeShopperModal extends React.Component<IChallengeShopperProps, State> {
  state = {
    isOpen: true,
  };

  @bind
  onComplete(result) {
    this.setState({ isOpen: false }, () => this.props.onComplete(result));
  }

  eventData(additionalContext = {}): IEventData {
    return {
      componentName: 'ChallengeShopperModal',
      context: {
        props: { ...this.props },
        ...additionalContext,
      },
    };
  }

  componentDidMount() {
    trackView(this.eventData());
    elog.info(`${TAG}.mount`, { ...this.eventData() });
  }

  // Adyen doesn't provide their own cancellation callback,
  // so if the user cancels the challenge flow (like closing the modal),
  // onComplete is triggered with a result that will cause the
  // 3DS submission process to fail gracefully.
  @bind
  onCancel() {
    this.onComplete('');
  }

  render() {
    return (
      <Modal
        isOpen={this.state.isOpen}
        paddedBody
        newClose
        onRequestClose={this.onCancel}
      >
        <ChallengeShopper
          challengeToken={this.props.challengeToken}
          onComplete={this.onComplete}
          onError={this.props.onError}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/threeds2/challenge_shopper_modal.tsx